import Factory from "../Factory";
import { FactoryInterface } from "../FactoryInterface";

import { Attachment } from "../Entities/Attachment/Attachment";
import { AttachmentInterface } from "../Entities/Attachment/AttachmentInterface";

class AttachmentFactory extends Factory implements FactoryInterface {

  public create(data: any): AttachmentInterface {
    return new Attachment({
      id: data.id,
      extension: data.extension,
      path: data.path,
      cropImgPath: data.cropImgPath,
      avatarPath: data.avatarPath,
      isAvatar: data.isAvatar,
      filename: data.filename,
      uuid: data.uuid,
      createdAt: data.createdAt,
      isPrivate: data.isPrivate,
      iconLink: data.iconLink,
      automaticallyCreated: data.automaticallyCreated || false
    });
  }

  public reinitialize(data: any): AttachmentInterface {
    return new Attachment({
      ...data
    });
  }
}

export default new AttachmentFactory();
